import { render } from "./BaseIndicatorDot.vue?vue&type=template&id=429f5c30"
import script from "./BaseIndicatorDot.vue?vue&type=script&lang=js"
export * from "./BaseIndicatorDot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__